import { getItems, getRids, merge, setItems } from '@shared/item-v0.1.0'
import type { NoodlNode } from '@shared/node-v1.0.0'
import type Surreal from 'surrealdb'
import type { Props } from '../definition'

export const initSurrealDb = async (p: Props, noodlNode: NoodlNode) => {
	const {
		surrealDbNamespace = 'default',
		surrealDbDatabase = 'data',
		useCustomSurrealDb,
		surrealDbUrl = 'ws://localhost:8000',
	} = p
	const { project, environment = 'd3' } = Noodl.getProjectSettings()

	if (!project || !environment) {
		log.error('SurrealDb init: empty required props', { project, environment })
		return
	}

	const surrealDbModule = await import('surrealdb')
	const { Surreal, r, surql, jsonify, PreparedQuery, RecordId, StringRecordId } = surrealDbModule

	const url = useCustomSurrealDb ? surrealDbUrl : `wss://surrealdb.${project}.${environment}.rolder.app`

	noodlNode._internal.surrealUrl = url

	const surrealInstance = new Surreal() as Surreal

	if (p.useNetwork) {
		if (R.db?.states.network.connected) {
			await connectToSurreal(surrealInstance, surrealDbNamespace, surrealDbDatabase, url)
			log.info('SurrealDB online init')
		} else {
			log.info('SurrealDB offline init - skipping connection')
		}
	} else {
		await connectToSurreal(surrealInstance, surrealDbNamespace, surrealDbDatabase, url)
		log.info('SurrealDB online init (no network check)')
	}

	R.surreal = {
		namespace: surrealDbNamespace,
		database: surrealDbDatabase,
		r,
		jsonify,
		surql,
		PreparedQuery,
		db: surrealInstance,
		getRids,
		getItems,
		setItems,
		merge,
		RecordId, 
		StringRecordId
	}
}

async function connectToSurreal(db: Surreal, namespace: string, database: string, url: string) {
	const st = log.start()

	if (db.connection?.status === 'connected') return
	if (db.connection?.status === 'connecting' || db.connection?.status === 'reconnecting') {
		await db.ready
		return
	}

	await db.connect(url, {
		namespace,
		database,
		reconnect: {
			enabled: true,
			attempts: -1,
		},
	})

	await db.ready

	log.end(`Surrealdb init ${url}`, st)
}
